module.exports = __webpack_public_path__ + "img/canara2.212b00f5.jpg";